import {
  SearchClassesClassListingEventProjector,
  SearchClassesShowCapabilities,
  SearchShortlistMembership,
} from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type ShowProps = {
  result: SearchClassesClassListingEventProjector["result"]
  shortlists: SearchShortlistMembership[]
  capabilities: SearchClassesShowCapabilities
}
export const useShowProps = () => useProps<ShowProps>()
